import { fetchAPI } from './api';

// Initialize variables from Rails
const pageData = window.brandsPageData || {};
let currentPage = pageData.currentPage || 1;
const perPage = pageData.perPage || 15;

// DOM helpers
const $ = (selector) => document.querySelector(selector);
const $$ = (selector) => document.querySelectorAll(selector);

// Search functionality
async function performSearch(query) {
  const brandsList = $('#brands-listing');
  brandsList?.classList.add('opacity-50');
  
  try {
    await fetchAPI(window.location.pathname, 'GET', { q: query, page: 1, per_page: perPage });
  } catch (error) {
    console.error('Error searching brands:', error);
  } finally {
    brandsList?.classList.remove('opacity-50');
  }
}

// Load more brands (pagination)
async function loadMoreBrands() {
  currentPage++;
  const loadMoreBtn = $('#get-more-brands');
  const loadMoreText = loadMoreBtn?.querySelector('p');
  
  loadMoreBtn?.classList.add('opacity-50');
  if (loadMoreText) loadMoreText.textContent = I18n.t('loading');
  
  try {
    await fetchAPI(window.location.pathname, 'GET', { page: currentPage, per_page: perPage });
  } catch (error) {
    currentPage--;
    console.error('Error loading more brands:', error);
  } finally {
    loadMoreBtn?.classList.remove('opacity-50');
    if (loadMoreText) loadMoreText.textContent = I18n.t('view_more');
  }
}

// Reset to initial state
async function resetToInitialState() {
  currentPage = 1;
  
  try {
    await fetchAPI(window.location.pathname, 'GET', { page: 1, per_page: perPage });
  } catch (error) {
    console.error('Error resetting to initial state:', error);
  }
}

// Search input handlers
$$('#brand-search, #brand-search-index').forEach(input => {
  input.addEventListener('keyup', (e) => {
    e.preventDefault();
    const searchQuery = e.target.value.trim();
    
    if (searchQuery.length === 0) {
      resetToInitialState();
    } else if (searchQuery.length > 1) {
      performSearch(searchQuery);
    }
  });
  
  input.addEventListener('input', (e) => {
    const clearButton = e.target.closest('.relative')?.querySelector('.gc-clear-search');
    clearButton?.classList.toggle('hidden', e.target.value.length === 0);
  });
});

// Clear search functionality
$$('.gc-clear-search').forEach(btn => {
  btn.addEventListener('click', () => {
    $$('#brand-search, #brand-search-index').forEach(input => input.value = '');
    btn.classList.add('hidden');
    resetToInitialState();
  });
});

// Load more brands button
$('#get-more-brands')?.addEventListener('click', (e) => {
  e.preventDefault();
  loadMoreBrands();
});

// Cart summary click handler
$('#cart-summary')?.addEventListener('click', () => {
  window.location.href = '/cart-summary';
});

// Hide native search cancel button
const searchInput = $('#searchform input[type="search"]');
if (searchInput) {
  const style = document.createElement('style');
  style.textContent = `
    #searchform input[type="search"]::-webkit-search-cancel-button,
    #searchform input[type="search"]::-moz-search-clear {
      -webkit-appearance: none;
      appearance: none;
      display: none;
    }
  `;
  document.head.appendChild(style);
}

// Gift popup handler
$$('.gift_popup').forEach(el => {
  el.addEventListener('click', async () => {
    try {
      await fetchAPI('/gift-popup', 'GET');
    } catch (error) {
      console.error('Error opening gift popup:', error);
    }
  });
});
